import http from '../common/http'

//维修凭证（小票）
export const getRepairSmallTicket = serviceOrderSysNo => (
	http.get('/RepairSmallTicket/GetRepairSmallTicket', { serviceOrderSysNo: serviceOrderSysNo })
)

//接机单
export const getRepairCertificate = serviceOrderSysNo => (
	http.get('/RepairSmallTicket/GetRepairCertificate', { serviceOrderSysNo: serviceOrderSysNo })
)



// WEBPACK FOOTER //
// ./src/api/repairSmallTicketApi.js